
import { useEffect, useState } from "react";
import styles from "./Auth.module.css";
import { useSelector } from "react-redux";
import GMallIcon from "./../../../assets/svg/gmall-logo-text.svg";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

const Auth = ({ title, children, wallpaper }) => {
  const navigate = useLangNavigate();
  const store = useSelector((state) => state);

  const [currentWallpaper, setCurrentWallpaper] = useState(wallpaper);
  const [previousWallpaper, setPreviousWallpaper] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (wallpaper === currentWallpaper) return;

    setPreviousWallpaper(currentWallpaper);
    setCurrentWallpaper(wallpaper);
    setIsTransitioning(true);

    const timeout = setTimeout(() => {
      setPreviousWallpaper(null);
      setIsTransitioning(false);
    }, 600);

    return () => clearTimeout(timeout);
  }, [wallpaper]);

  useEffect(() => {
    if (store.Login.is_login) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.LoginPageContainer}>
      <div className={styles.TopImageContainer}>
        {previousWallpaper && (
          <img
            src={previousWallpaper}
            alt=""
            className={`${styles.Wallpaper} ${styles.WallpaperPrevious}`}
          />
        )}

        <img
          key={currentWallpaper}
          src={currentWallpaper}
          alt="city"
          className={`${styles.Wallpaper} ${
            isTransitioning ? styles.WallpaperVisible : ""
          }`}
        />

        <img
          src={GMallIcon}
          width={76}
          height={45}
          className={styles.GMall}
          alt="auth"
        />
      </div>

      <div className={styles.ContentContainer}>
        <div className={styles.Section}>
          <div className={styles.Title}>{title}</div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Auth;
